import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dialogOverlayFn = /* @__PURE__ */ createRecipe('dialogOverlay', {}, [])

const dialogOverlayVariantMap = {}

const dialogOverlayVariantKeys = Object.keys(dialogOverlayVariantMap)

export const dialogOverlay = /* @__PURE__ */ Object.assign(memo(dialogOverlayFn.recipeFn), {
  __recipe__: true,
  __name__: 'dialogOverlay',
  __getCompoundVariantCss__: dialogOverlayFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dialogOverlayVariantKeys,
  variantMap: dialogOverlayVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dialogOverlayVariantKeys)
  },
  getVariantProps: dialogOverlayFn.getVariantProps,
})